module.exports = __webpack_public_path__ + "static/media/apple-pay-id.a49225e9.svg";